import { useNavigate, useRouterState } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';
import { useSessionExpiry } from '../../lib/session-expiry';
import { SessionExpiredDialog } from './session-expired-dialog';

/** Mounted once at the root: shows the dialog when the API says the session has ended. */
export function SessionExpiryHost() {
  const { expired, dismiss, reset } = useSessionExpiry();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const staff = useRouterState({ select: (s) => s.location.pathname.startsWith('/subdomain/admin') });

  const signInAgain = () => {
    reset();
    // Cached data belongs to the account that just ended; the next sign-in must not see it.
    queryClient.clear();
    void navigate({ to: staff ? '/subdomain/admin/admin-login' : '/subdomain/app/sign-in' });
  };

  return <SessionExpiredDialog open={expired} onSignIn={signInAgain} onDismiss={dismiss} />;
}
